import { Action, createReducer, on } from '@ngrx/store';
import { GenesysCloudFeatureTogglesState, initialState } from '../genesys-cloud-feature-toggles.state';
import { allFeatureTogglesLoaded } from '../actions/feature-toggles.actions';

const reducer = createReducer(
  initialState(),
  on(allFeatureTogglesLoaded, (state, { featureToggles }): GenesysCloudFeatureTogglesState => ({
    ...state,
    featureToggles,
    featureTogglesLoaded: true
  }))
);

export function genesysCloudFeatureTogglesReducer(state: GenesysCloudFeatureTogglesState, action: Action): GenesysCloudFeatureTogglesState {
  return reducer(state, action);
}
